import { takeLatest, take, put, select } from 'redux-saga/effects';
import { consts as saved } from './saved';
import { consts as submit } from './submit';
import {
  consts as upcoming,
  paginatedConsts as paginatedUpcoming,
} from './upcoming';
import { consts as answered } from './answered';
import { targetUserIdSelector } from '../context/selectors';

function* getIncomingSurveysWorker(action) {
  yield take(submit.SUCCEED);
  yield put({
    type: submit.MESSAGE,
    payload: action.payload.message,
  });
  const id = yield select(targetUserIdSelector);

  yield put({
    type: upcoming.DELETE_ANSWERED_ITEM,
    payload: action.payload.surveyId,
  });

  yield put({
    type: paginatedUpcoming.LOAD_NEXT_REQUESTS,
    payload: { limit: 1, id: action.payload.userId },
  });

  const { userId, surveyId } = action.payload;
  yield put({
    type: saved.REMOVE_SURVEY,
    payload: { userId, surveyId },
  });

  yield put({
    type: answered.SEND,
    payload: { id },
  });
}

export function* getIncomingSurveysSaga() {
  yield takeLatest(submit.SEND, getIncomingSurveysWorker);
}



// WEBPACK FOOTER //
// ./src/redux/surveys/getIncomingSurveysSaga.js